<div class="h-100 single-report-page">
    <app-admin-report [columns]="driverReport" [hasFilters]="true" [apiUrl]="reportAPI" [isExportToExcel]="true"
                      reportTitle="ADMINISTRATION.DRIVER_PACKAGES_SUMMARY_REPORT_TITLE"
                      [queryParams]="{'driverType': 'TYPICAL'}">
    </app-admin-report>
</div>
